module.exports = __webpack_public_path__ + "static/index/img/baikal-404.cdef1887.jpg";